const BYTES_UNIT_BASE = 1024;
const BYTES_DECIMAL_PLACES = 2;
const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
/**
 * Formats the bytes to a human readable format.
 * @param bytes - The number of bytes to format.
 * @returns The formatted bytes.
 * @example
 * formatBytes(1024) => '1KB'
 * formatBytes(1024 * 1024) => '1MB'
 * formatBytes(1024 * 1024 * 1024) => '1GB'
 * formatBytes(1024 * 1024 * 1024 * 1024) => '1TB'
 */
export function formatBytes(bytes) {
    if (!bytes || isNaN(bytes) || !Number.isFinite(bytes) || bytes < 0) {
        return `0 ${units[0]}`;
    }
    const index = Math.floor(Math.log(bytes) / Math.log(BYTES_UNIT_BASE));
    const safeIndex = Math.min(index, units.length - 1);
    return (bytes / Math.pow(BYTES_UNIT_BASE, safeIndex)).toFixed(BYTES_DECIMAL_PLACES) + ' ' + units[safeIndex];
}
